import TwoFactory from './TwoFactory';
import TwoFactoryCheckForm from './TwoFactoryCheckForm';
import TwoFactoryForm from './TwoFactoryForm';

export { TwoFactory, TwoFactoryCheckForm, TwoFactoryForm };

export default TwoFactory;
